module.exports = __webpack_public_path__ + "static/information9-12ac984874b54b811ded5caf12055002.png";